import { render, staticRenderFns } from "./VaccineAlarm.vue?vue&type=template&id=64787c4e&scoped=true&"
import script from "./VaccineAlarm.vue?vue&type=script&lang=js&"
export * from "./VaccineAlarm.vue?vue&type=script&lang=js&"
import style0 from "./VaccineAlarm.vue?vue&type=style&index=0&id=64787c4e&lang=scss&scoped=true&"
import style1 from "./VaccineAlarm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64787c4e",
  null
  
)

export default component.exports